<template>
  <v-content class="content">
    <v-container fill-height>
      <v-layout align-center justify-center>
        <v-card class="content-container px-4 py-4">
          <h5 class="title pt-4">Reset Password</h5>

          <v-form ref="form" class="mt-5" v-model="valid" @submit.stop.prevent>
            <div class="text-xs-left">Email</div>
            <v-text-field
              name="email"
              label="Enter your email here."
              type="email"
              v-model="$v.email.$model"
              :error="$v.email.$error"
              :error-messages="$v.email.$dirty ? emailErrors : []"
              v-on:keyup.enter.prevent.stop="
                valid && !$v.email.$error ? reset() : null
              "
              required
              class="mt-1 default-input"
              solo
            >
            </v-text-field>
          </v-form>

          <v-btn
            class="primary text-capitalize"
            :disabled="!valid || $v.email.$error"
            @click.prevent.stop="reset"
            block
          >
            Send Reset Link
          </v-btn>

          <v-btn
            @click="$router.back()"
            class="text-capitalize mt-4"
            flat
            block
          >
            Back
          </v-btn>
        </v-card>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import { firebase } from '@firebase/app';
import '@firebase/auth';
import { email, required } from 'vuelidate/lib/validators';
import { emailFormatter } from '@/constants/variables';

export default {
  name: 'ResetPassword',
  data() {
    return {
      valid: false,
      email: this.$route.query.email,
    };
  },
  validations: {
    email: {
      email: val => email(emailFormatter(val)),
      required,
    },
  },
  computed: {
    emailErrors() {
      if (!this.$v.email.required) {
        return ['E-mail is required'];
      } else if (!this.$v.email.email) {
        return ['E-mail must be valid'];
      }
      return [];
    },
  },
  methods: {
    async reset() {
      console.log('call reset');
      await this.$v.email.$touch();

      if (!this.$v.email.$error) {
        const auth = firebase.auth();

        const email = this.email;
        if (!email) {
          this.$store.dispatch('application/setErrorNotification', {
            message: 'Please enter the email.',
          });
        }
        try {
          await auth.sendPasswordResetEmail(email);
          this.$store.dispatch('application/setSuccessNotification', {
            message: `An email with the password reset link has been sent to ${email}!`,
          });

          this.$router.back();
        } catch (e) {
          console.log(e);
          if (e.code === 'auth/invalid-email') {
            this.$store.dispatch('application/setErrorNotification', {
              message: 'Invalid email. Please check and try again.',
            });
          } else if (e.code === 'auth/user-not-found') {
            this.$store.dispatch('application/setErrorNotification', {
              message:
                'There is no account associated with this email. Please check and try again.',
            });
          } else {
            this.$store.dispatch('application/setErrorNotification', {
              message: e,
            });
          }
        }
      }
    },
  },
};
</script>

<style scoped lang="postcss">
.content {
  font-family: var(--font-family-sans);
}
.content-container {
  width: 400px;
}
.title {
  font-size: 24px !important;
  font-weight: bold;
}
.v-toolbar {
  background-color: #46535c;
}
</style>
